export default {
  headerName: 'Nombre',
  headerCode: 'Código',
  headerActions: 'Acciones'
}
